export const translations = {
  de: {
    nav: {
      home: 'Startseite',
      about: 'Über uns',
      services: 'Dienstleistungen',
      projects: 'Projekte',
      contact: 'Kontakt'
    },
    hero: {
      title: 'Professionelle Reinigung für jeden Raum',
      subtitle: 'Seit 2017 bieten wir zuverlässige Reinigungsdienstleistungen für Unternehmen in Hamburg und Umgebung.',
      requestQuote: 'Angebot anfordern'
    },
    stats: {
      clients: 'Zufriedene Kunden',
      experience: 'Jahre Erfahrung'
    },
    services: {
      title: 'Umfassende Reinigungslösungen',
      subtitle: 'Von Geschäftsräumen bis hin zu spezialisierten Einrichtungen bieten wir außergewöhnliche Reinigungsdienstleistungen, die auf Ihre spezifischen Bedürfnisse zugeschnitten sind.',
      categories: {
        commercial: {
          title: 'Gewerblich',
          description: 'Professionelle Reinigung für Büros, Einzelhandel und Geschäftskomplexe'
        },
        industrial: {
          title: 'Industriell',
          description: 'Spezialisierte Reinigung für Fabriken, Lagerhallen und Produktionsanlagen'
        },
        special: {
          title: 'Spezielle Einrichtungen',
          description: 'Umfassende Reinigung für Stadien, Arenen und Veranstaltungsorte'
        },
        residential: {
          title: 'Wohnbereich',
          description: 'Qualitätsreinigung für Wohnungen und Wohnkomplexe'
        },
        institutional: {
          title: 'Institutionell',
          description: 'Gewidmete Reinigung für Schulen, Gesundheitseinrichtungen und öffentliche Gebäude'
        },
        specialized: {
          title: 'Spezialisiert',
          description: 'Expertenservice einschließlich Bau-Endreinigung und Sonderreinigung'
        }
      },
      features: {
        commercial: 'Regelmäßige Reinigung, Bodenreinigung',
        industrial: 'Maschinenreinigung, Hallenboden, Industrieanlagen',
        special: 'Event-Reinigung, Tribünen, VIP-Bereiche',
        residential: 'Wohnungsreinigung, Treppenhausreinigung, Außenanlagen',
        institutional: 'Klassenräume, Sanitäranlagen, Kantinen',
        specialized: 'Bauabschlussreinigung, Sonderreinigung'
      },
      learnMore: 'Mehr erfahren'
    },
    standards: {
      title: 'Unsere Servicestandards',
      subtitle: 'Professionelle Reinigungsdienstleistungen mit Engagement und Sorgfalt',
      team: {
        title: 'Professionelles Team',
        description: 'Erfahrene und gut ausgebildete Reinigungsspezialisten'
      },
      reliability: {
        title: 'Zuverlässiger Service',
        description: 'Pünktliche und konstante Reinigungsdienstleistungen'
      },
      quality: {
        title: 'Qualitätsarbeit',
        description: 'Gründlicher und detaillierter Reinigungsprozess'
      }
    },
    about: {
      title: 'Über Asena UG',
      subtitle: 'Ihr vertrauenswürdiger Partner für professionelle Reinigungsdienstleistungen',
      values: {
        professionalism: {
          title: 'Professionalität',
          description: 'Höchste Standards in allen Aspekten unserer Arbeit'
        },
        reliability: {
          title: 'Zuverlässigkeit',
          description: 'Pünktlich und konsistent in unseren Dienstleistungen'
        },
        excellence: {
          title: 'Exzellenz',
          description: 'Streben nach kontinuierlicher Verbesserung'
        }
      },
      history: {
        title: 'Unsere Geschichte',
        content: 'Asena UG wurde 2017 gegründet und hat sich seither zu einem zuverlässigen Anbieter von Reinigungsdienstleistungen in Hamburg entwickelt.'
      },
      mission: {
        title: 'Unsere Mission',
        content: 'Wir streben danach, durch erstklassige Reinigungsdienstleistungen und kundenorientierten Service einen Mehrwert für unsere Kunden zu schaffen.'
      }
    },
    projects: {
      title: 'Unsere Projekte',
      subtitle: 'Einblicke in unsere erfolgreichen Reinigungsprojekte',
      stadium: {
        title: 'Stadionreinigung',
        description: 'Umfassende Reinigung des Volksparkstadions'
      },
      business: {
        title: 'Geschäftszentrum',
        description: 'Regelmäßige Reinigung eines großen Geschäftskomplexes'
      },
      event: {
        title: 'Veranstaltungszentrum',
        description: 'Spezialisierte Reinigung für Großveranstaltungen'
      },
      stats: {
        area: 'Reinigungsfläche',
        seats: 'Sitzplätze',
        cleaningTime: 'Reinigungszeit',
        buildings: 'Gebäude',
        offices: 'Büros',
        dailyVisitors: 'Tägliche Besucher',
        events: 'Veranstaltungen pro Jahr',
        venues: 'Veranstaltungsorte',
        satisfaction: 'Kundenzufriedenheit'
      }
    },
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir freuen uns darauf, von Ihnen zu hören',
      form: {
        name: 'Name',
        email: 'E-Mail',
        message: 'Nachricht',
        sending: 'Wird gesendet...',
        submit: 'Absenden',
        success: 'Ihre Nachricht wurde erfolgreich gesendet!',
        error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.'
      }
    },
    quote: {
      service: 'Dienstleistung',
      selectService: 'Dienstleistung auswählen',
      phone: 'Telefon',
      submit: 'Angebot anfordern',
      success: 'Ihre Anfrage wurde erfolgreich gesendet!',
      error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.'
    },
    footer: {
      description: 'Professionelle Reinigungsdienstleistungen seit 2017',
      contact: {
        title: 'Kontakt'
      },
      legal: {
        title: 'Rechtliches',
        impressum: 'Impressum',
        privacy: 'Datenschutz',
        terms: 'AGB'
      },
      rights: 'Alle Rechte vorbehalten.'
    },
    impressum: {
      title: 'Impressum',
      companyDetails: {
        title: 'Unternehmensdetails',
        address: 'Holzmühlenstraße 33'
      },
      contact: {
        title: 'Kontakt',
        phone: 'Telefon',
        email: 'E-Mail'
      },
      registration: {
        title: 'Handelsregister',
        court: 'Registergericht',
        number: 'Handelsregisternummer',
        vatId: 'USt-IdNr'
      },
      management: {
        title: 'Geschäftsführung',
        content: 'Birgyül Achakel'
      },
      responsibility: {
        title: 'Inhaltlich Verantwortlicher',
        content: 'Gemäß § 55 Abs. 2 RStV: Birgyül Achakel'
      }
    },
    privacy: {
      title: 'Datenschutzerklärung',
      introduction: {
        title: 'Einleitung',
        content: 'Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003).'
      },
      dataCollection: {
        title: 'Datenerfassung',
        content: 'Wir erfassen und speichern die Daten, die Sie uns bei der Kontaktaufnahme mitteilen. In unseren Logfiles speichern wir Informationen, die Ihr Browser an uns übermittelt.'
      },
      dataUse: {
        title: 'Datenverwendung',
        content: 'Die von Ihnen bereitgestellten Daten verwenden wir ausschließlich, um Ihre Anfragen zu bearbeiten und unsere Dienstleistungen zu erbringen.'
      },
      cookies: {
        title: 'Cookies',
        content: 'Unsere Website verwendet Cookies, um unseren Service für Sie zu verbessern. Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden.'
      },
      rights: {
        title: 'Ihre Rechte',
        content: 'Sie haben jederzeit das Recht auf Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung.'
      },
      contact: {
        title: 'Kontakt für Datenschutz',
        name: 'Datenschutzbeauftragter: Birgyül Achakel',
        email: 'E-Mail',
        phone: 'Telefon'
      }
    },
    terms: {
      title: 'Allgemeine Geschäftsbedingungen',
      scope: {
        title: 'Geltungsbereich',
        content: 'Diese AGB gelten für alle Geschäftsbeziehungen zwischen uns und unseren Kunden.'
      },
      services: {
        title: 'Leistungen',
        content: 'Art und Umfang der Leistungen ergeben sich aus der Leistungsbeschreibung oder dem individuellen Angebot.'
      },
      pricing: {
        title: 'Preise und Zahlung',
        content: 'Alle Preise verstehen sich in Euro zzgl. der gesetzlichen Mehrwertsteuer.'
      },
      payment: {
        title: 'Zahlungsbedingungen',
        content: 'Rechnungen sind innerhalb von 14 Tagen nach Rechnungsstellung ohne Abzug zur Zahlung fällig.'
      },
      liability: {
        title: 'Haftung',
        content: 'Wir haften für Schäden nur bei Vorsatz oder grober Fahrlässigkeit.'
      },
      termination: {
        title: 'Kündigung',
        content: 'Der Vertrag kann von beiden Seiten mit einer Frist von 30 Tagen zum Monatsende gekündigt werden.'
      },
      jurisdiction: {
        title: 'Gerichtsstand',
        content: 'Gerichtsstand ist Hamburg. Es gilt deutsches Recht.'
      }
    }
  },
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      services: 'Hizmetler',
      projects: 'Projeler',
      contact: 'İletişim'
    },
    hero: {
      title: 'Her Mekan için Profesyonel Temizlik',
      subtitle: '2017\'den beri Hamburg ve çevresindeki işletmelere güvenilir temizlik hizmetleri sunuyoruz.',
      requestQuote: 'Teklif Al'
    },
    stats: {
      clients: 'Memnun Müşteri',
      experience: 'Yıl Deneyim'
    },
    services: {
      title: 'Kapsamlı Temizlik Çözümleri',
      subtitle: 'Ticari alanlardan özel tesislere kadar, özel ihtiyaçlarınıza göre özelleştirilmiş olağanüstü temizlik hizmetleri sunuyoruz.',
      categories: {
        commercial: {
          title: 'Ticari',
          description: 'Ofisler, perakende alanları ve iş kompleksleri için profesyonel temizlik'
        },
        industrial: {
          title: 'Endüstriyel',
          description: 'Fabrikalar, depolar ve üretim tesisleri için özel temizlik'
        },
        special: {
          title: 'Özel Tesisler',
          description: 'Stadyumlar, arenalar ve etkinlik mekanları için kapsamlı temizlik'
        },
        residential: {
          title: 'Konut',
          description: 'Daireler ve konut kompleksleri için kaliteli temizlik hizmetleri'
        },
        institutional: {
          title: 'Kurumsal',
          description: 'Okullar, sağlık tesisleri ve kamu binaları için özel temizlik'
        },
        specialized: {
          title: 'Özelleştirilmiş',
          description: 'İnşaat sonrası ve özel temizlik dahil uzman hizmetler'
        }
      },
      features: {
        commercial: 'Düzenli temizlik, zemin temizliği',
        industrial: 'Makine temizliği, fabrika zemini, endüstriyel ekipman',
        special: 'Etkinlik temizliği, tribünler, VIP alanları',
        residential: 'Ev temizliği, merdiven temizliği, dış mekan',
        institutional: 'Sınıflar, tuvaletler, kantinler',
        specialized: 'İnşaat sonrası temizlik, özel temizlik'
      },
      learnMore: 'Daha Fazla Bilgi'
    },
    standards: {
      title: 'Hizmet Standartlarımız',
      subtitle: 'Özveri ve özenle profesyonel temizlik hizmetleri',
      team: {
        title: 'Profesyonel Ekip',
        description: 'Deneyimli ve iyi eğitimli temizlik uzmanları'
      },
      reliability: {
        title: 'Güvenilir Hizmet',
        description: 'Dakik ve tutarlı temizlik hizmetleri'
      },
      quality: {
        title: 'Kaliteli İş',
        description: 'Kapsamlı ve detaylı temizlik süreci'
      }
    },
    about: {
      title: 'Hakkımızda',
      subtitle: 'Profesyonel temizlik hizmetlerinde güvenilir ortağınız',
      values: {
        professionalism: {
          title: 'Profesyonellik',
          description: 'İşimizin her alanında en yüksek standartlar'
        },
        reliability: {
          title: 'Güvenilirlik',
          description: 'Hizmetlerimizde dakik ve tutarlı'
        },
        excellence: {
          title: 'Mükemmellik',
          description: 'Sürekli gelişim için çaba'
        }
      },
      history: {
        title: 'Tarihçemiz',
        content: 'Asena UG, 2017 yılında kuruldu ve o zamandan beri Hamburg\'da güvenilir bir temizlik hizmetleri sağlayıcısı haline geldi.'
      },
      mission: {
        title: 'Misyonumuz',
        content: 'Birinci sınıf temizlik hizmetleri ve müşteri odaklı yaklaşımımızla müşterilerimize değer katmayı hedefliyoruz.'
      }
    },
    projects: {
      title: 'Projelerimiz',
      subtitle: 'Başarılı temizlik projelerimizden örnekler',
      stadium: {
        title: 'Stadyum Temizliği',
        description: 'Volksparkstadion\'un kapsamlı temizliği'
      },
      business: {
        title: 'İş Merkezi',
        description: 'Büyük bir iş kompleksinin düzenli temizliği'
      },
      event: {
        title: 'Etkinlik Merkezi',
        description: 'Büyük etkinlikler için özel temizlik'
      },
      stats: {
        area: 'Temizlik Alanı',
        seats: 'Koltuk',
        cleaningTime: 'Temizlik Süresi',
        buildings: 'Bina',
        offices: 'Ofis',
        dailyVisitors: 'Günlük Ziyaretçi',
        events: 'Yıllık Etkinlik',
        venues: 'Mekan',
        satisfaction: 'Müşteri Memnuniyeti'
      }
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Sizden haber almayı bekliyoruz',
      form: {
        name: 'İsim',
        email: 'E-posta',
        message: 'Mesaj',
        sending: 'Gönderiliyor...',
        submit: 'Gönder',
        success: 'Mesajınız başarıyla gönderildi!',
        error: 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.'
      }
    },
    quote: {
      service: 'Hizmet',
      selectService: 'Hizmet seçin',
      phone: 'Telefon',
      submit: 'Teklif Al',
      success: 'Talebiniz başarıyla gönderildi!',
      error: 'Bir hata oluştu. Lütfen daha sonra tekrar deneyin.'
    },
    footer: {
      description: '2017\'den beri profesyonel temizlik hizmetleri',
      contact: {
        title: 'İletişim'
      },
      legal: {
        title: 'Yasal',
        impressum: 'Künye',
        privacy: 'Gizlilik Politikası',
        terms: 'Kullanım Koşulları'
      },
      rights: 'Tüm hakları saklıdır.'
    },
    impressum: {
      title: 'Künye',
      companyDetails: {
        title: 'Şirket Bilgileri',
        address: 'Musterstraße 123'
      },
      contact: {
        title: 'İletişim',
        phone: 'Telefon',
        email: 'E-posta'
      },
      registration: {
        title: 'Ticaret Sicili',
        court: 'Tescil Mahkemesi',
        number: 'Ticaret Sicil Numarası',
        vatId: 'Vergi Numarası'
      },
      management: {
        title: 'Yönetim',
        content: 'Max Mustermann'
      },
      responsibility: {
        title: 'İçerikten Sorumlu',
        content: '§ 55 Abs. 2 RStV uyarınca: Max Mustermann'
      }
    },
    privacy: {
      title: 'Gizlilik Politikası',
      introduction: {
        title: 'Giriş',
        content: 'Kişisel verilerinizin korunması bizim için özel önem taşımaktadır. Verilerinizi yalnızca yasal düzenlemeler (GDPR) çerçevesinde işliyoruz.'
      },
      dataCollection: {
        title: 'Veri Toplama',
        content: 'Bizimle iletişime geçerken paylaştığınız verileri topluyoruz ve saklıyoruz. Log dosyalarımızda, tarayıcınızın bize ilettiği bilgileri saklıyoruz.'
      },
      dataUse: {
        title: 'Veri Kullanımı',
        content: 'Sağladığınız verileri yalnızca taleplerinizi işlemek ve hizmetlerimizi sunmak için kullanıyoruz.'
      },
      cookies: {
        title: 'Çerezler',
        content: 'Web sitemiz, hizmetimizi sizin için iyileştirmek amacıyla çerezler kullanmaktadır. Tarayıcınızı çerezlerin ayarlanması hakkında bilgilendirilecek şekilde ayarlayabilirsiniz.'
      },
      rights: {
        title: 'Haklarınız',
        content: 'Saklanan kişisel verileriniz, kaynağı, alıcıları ve veri işlemenin amacı hakkında her zaman bilgi alma hakkına sahipsiniz.'
      },
      contact: {
        title: 'Veri Koruma İletişimi',
        name: 'Veri Koruma Görevlisi: Max Mustermann',
        email: 'E-posta',
        phone: 'Telefon'
      }
    },
    terms: {
      title: 'Kullanım Koşulları',
      scope: {
        title: 'Kapsam',
        content: 'Bu genel şartlar, bizimle müşterilerimiz arasındaki tüm iş ilişkileri için geçerlidir.'
      },
      services: {
        title: 'Hizmetler',
        content: 'Hizmetlerin türü ve kapsamı, hizmet açıklamasında veya bireysel teklifte belirtilmiştir.'
      },
      pricing: {
        title: 'Fiyatlar ve Ödeme',
        content: 'Tüm fiyatlar Euro cinsindendir ve yasal KDV hariçtir.'
      },
      payment: {
        title: 'Ödeme Koşulları',
        content: 'Faturalar, fatura tarihinden itibaren 14 gün içinde indirim yapılmaksızın ödenmelidir.'
      },
      liability: {
        title: 'Sorumluluk',
        content: 'Hasarlardan yalnızca kasıt veya ağır ihmal durumunda sorumluyuz.'
      },
      termination: {
        title: 'Fesih',
        content: 'Sözleşme, her iki tarafça 30 günlük bildirim süresiyle ay sonunda feshedilebilir.'
      },
      jurisdiction: {
        title: 'Yargı Yetkisi',
        content: 'Yargı yeri Hamburg\'dur. Alman hukuku geçerlidir.'
      }
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      projects: 'Projects',
      contact: 'Contact'
    },
    hero: {
      title: 'Professional Cleaning for Every Space',
      subtitle: 'Since 2017, we have been providing reliable cleaning services for businesses in Hamburg and surrounding areas.',
      requestQuote: 'Request Quote'
    },
    stats: {
      clients: 'Satisfied Clients',
      experience: 'Years Experience'
    },
    services: {
      title: 'Comprehensive Cleaning Solutions',
      subtitle: 'From commercial spaces to specialized facilities, we provide exceptional cleaning services tailored to your specific needs.',
      categories: {
        commercial: {
          title: 'Commercial',
          description: 'Professional cleaning for offices, retail spaces, and business complexes'
        },
        industrial: {
          title: 'Industrial',
          description: 'Specialized cleaning for factories, warehouses, and production facilities'
        },
        special: {
          title: 'Special Facilities',
          description: 'Comprehensive cleaning for stadiums, arenas, and event venues'
        },
        residential: {
          title: 'Residential',
          description: 'Quality cleaning services for apartments and residential complexes'
        },
        institutional: {
          title: 'Institutional',
          description: 'Dedicated cleaning for schools, healthcare facilities, and public buildings'
        },
        specialized: {
          title: 'Specialized',
          description: 'Expert services including post-construction and special cleaning'
        }
      },
      features: {
        commercial: 'Regular cleaning, floor maintenance',
        industrial: 'Machine cleaning, factory floors, industrial equipment',
        special: 'Event cleaning, bleachers, VIP areas',
        residential: 'Apartment cleaning, stairwell cleaning, exterior areas',
        institutional: 'Classrooms, sanitary facilities, cafeterias',
        specialized: 'Post-construction cleaning, special cleaning'
      },
      learnMore: 'Learn More'
    },
    standards: {
      title: 'Our Service Standards',
      subtitle: 'Delivering professional cleaning services with dedication and care',
      team: {
        title: 'Professional Team',
        description: 'Experienced and well-trained cleaning specialists'
      },
      reliability: {
        title: 'Reliable Service',
        description: 'Punctual and consistent cleaning services'
      },
      quality: {
        title: 'Quality Work',
        description: 'Thorough and detailed cleaning process'
      }
    },
    about: {
      title: 'About Asena UG',
      subtitle: 'Your trusted partner in professional cleaning services',
      values: {
        professionalism: {
          title: 'Professionalism',
          description: 'Highest standards in all aspects of our work'
        },
        reliability: {
          title: 'Reliability',
          description: 'Punctual and consistent in our services'
        },
        excellence: {
          title: 'Excellence',
          description: 'Striving for continuous improvement'
        }
      },
      history: {
        title: 'Our History',
        content: 'Asena UG was founded in 2017 and has since developed into a reliable provider of cleaning services in Hamburg.'
      },
      mission: {
        title: 'Our Mission',
        content: 'We strive to create value for our clients through first-class cleaning services and customer-oriented service.'
      }
    },
    projects: {
      title: 'Our Projects',
      subtitle: 'Insights into our successful cleaning projects',
      stadium: {
        title: 'Stadium Cleaning',
        description: 'Comprehensive cleaning of Volksparkstadion'
      },
      business: {
        title: 'Business Center',
        description: 'Regular cleaning of a large business complex'
      },
      event: {
        title: 'Event Center',
        description: 'Specialized cleaning for large events'
      },
      stats: {
        area: 'Cleaning Area',
        seats: 'Seats',
        cleaningTime: 'Cleaning Time',
        buildings: 'Buildings',
        offices: 'Offices',
        dailyVisitors: 'Daily Visitors',
        events: 'Events per Year',
        venues: 'Venues',
        satisfaction: 'Customer Satisfaction'
      }
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'We look forward to hearing from you',
      form: {
        name: 'Name',
        email: 'Email',
        message: 'Message',
        sending: 'Sending...',
        submit: 'Submit',
        success: 'Your message has been sent successfully!',
        error: 'An error occurred. Please try again later.'
      }
    },
    quote: {
      service: 'Service',
      selectService: 'Select service',
      phone: 'Phone',
      submit: 'Request Quote',
      success: 'Your request has been sent successfully!',
      error: 'An error occurred. Please try again later.'
    },
    footer: {
      description: 'Professional cleaning services since 2017',
      contact: {
        title: 'Contact'
      },
      legal: {
        title: 'Legal',
        impressum: 'Legal Notice',
        privacy: 'Privacy Policy',
        terms: 'Terms & Conditions'
      },
      rights: 'All rights reserved.'
    },
    impressum: {
      title: 'Legal Notice',
      companyDetails: {
        title: 'Company Details',
        address: 'Musterstraße 123'
      },
      contact: {
        title: 'Contact',
        phone: 'Phone',
        email: 'Email'
      },
      registration: {
        title: 'Commercial Register',
        court: 'Registration Court',
        number: 'Commercial Register Number',
        vatId: 'VAT ID'
      },
      management: {
        title: 'Management',
        content: 'Max Mustermann'
      },
      responsibility: {
        title: 'Responsible for Content',
        content: 'According to § 55 Abs. 2 RStV: Max Mustermann'
      }
    },
    privacy: {
      title: 'Privacy Policy',
      introduction: {
        title: 'Introduction',
        content: 'The protection of your personal data is of particular concern to us. We process your data exclusively based on legal regulations (GDPR).'
      },
      dataCollection: {
        title: 'Data Collection',
        content: 'We collect and store the data you share when contacting us. In our log files, we store information that your browser transmits to us.'
      },
      dataUse: {
        title: 'Data Use',
        content: 'We use the data you provide exclusively to process your inquiries and provide our services.'
      },
      cookies: {
        title: 'Cookies',
        content: 'Our content: Our website uses cookies to improve our service for you. You can set your browser to be informed about the setting of cookies.'
      },
      rights: {
        title: 'Your Rights',
        content: 'You have the right to receive information about your stored personal data, its origin and recipients, and the purpose of data processing at any time.'
      },
      contact: {
        title: 'Data Protection Contact',
        name: 'Data Protection Officer: Max Mustermann',
        email: 'Email',
        phone: 'Phone'
      }
    },
    terms: {
      title: 'Terms and Conditions',
      scope: {
        title: 'Scope',
        content: 'These terms and conditions apply to all business relationships between us and our customers.'
      },
      services: {
        title: 'Services',
        content: 'The type and scope of services are defined in the service description or individual offer.'
      },
      pricing: {
        title: 'Prices and Payment',
        content: 'All prices are in Euro and exclude statutory VAT.'
      },
      payment: {
        title: 'Payment Terms',
        content: 'Invoices are due for payment without deduction within 14 days of invoicing.'
      },
      liability: {
        title: 'Liability',
        content: 'We are only liable for damages in cases of intent or gross negligence.'
      },
      termination: {
        title: 'Termination',
        content: 'The contract can be terminated by either party with 30 days notice to the end of the month.'
      },
      jurisdiction: {
        title: 'Jurisdiction',
        content: 'Place of jurisdiction is Hamburg. German law applies.'
      }
    }
  }
};